module.exports = __webpack_public_path__ + "img/test-robot-photo.e683a645.png";